import Vue from "vue";
import Router from "vue-router";
import MainLayout from '@/components/MainLayout.vue';
import HomePage from "@/components/HomePage.vue";
import RunningDataComparisonTools from "@/components/RunningDataComparisonTools.vue";
import DataParse from "@/components/DataParse.vue";
import Logs from "@/components/Logs.vue";

Vue.use(Router);

export default new Router({
  mode: "hash", // 可改为 "hash"，如需使用哈希模式
  routes: [
    {
      path: "/home",
      component: MainLayout,
      children: [
        {
          path: "/home",
          name: "Home",
          component: HomePage,
          meta: { title: '' },
        },
        {
          path: "/running-data-comparison-tools",
          name: "RunningDataComparisonTools",
          component: RunningDataComparisonTools,
          meta: { title: '跑步数据对比工具' },
        },
        {
          path: "/data-parse",
          name: "DataParse",
          component: DataParse,
          meta: { title: '跑步数据解析工具' },
        },
        {
          path: "/trajectory-comparison-tools",
          name: "TrajectoryComparisonTools",
          component: () => import("@/components/TrajectoryComparisonTools.vue"),
          meta: { title: 'GPS轨迹对比工具' },
        },
        {
          path: "/guide",
          name: "Guide",
          component: () => import("@/components/Guide.vue"),
          meta: { title: '使用指南' },
        },
        {
          path: "/logs",
          name: "Logs",
          component: Logs,
          meta: { title: '更新日志' },
        },
      ]
    },
    {
      path: '*', // 匹配其他未定义的路由
      redirect: '/home',
    },
  ],
});
